/**
 * Single source of truth for IDX Launchlab Platform PDA registration + create flow.
 * Used by UI config, register script (via duplicate constants in scripts/), and docs.
 */

/** IDX company platform wallet — admin, claim, and lock NFT recipient */
export const IDX_LAUNCHLAB_PLATFORM_WALLET =
  "DPByYJaAF7vxiBUCj3JcV58EZYN539xEMr1hJzUrdc7s";

/** Previous mainnet platform (retired — claim fees with old admin keypair). */
export const IDX_LAUNCHLAB_LEGACY_PLATFORM = {
  wallet: "E61t1AED61nWuVi4Wx5M3dAnonR7Qesx2n3uYBJTUBPB",
  pda: "8uwxihArrxv8dckZjJRWniJqDrb7iueYCxhZvvfd9DbX",
};

/** LP split scales for CreatePlatformConfig (must sum to 1_000_000) */
export const IDX_LAUNCHLAB_ON_CHAIN_LP_SPLIT = {
  burnScale: 900_000,
  creatorScale: 50_000,
  platformScale: 50_000,
};

/** PlatformConfig fee_rate / creator_fee_rate (per 1_000_000) = 0.5% each */
export const IDX_LAUNCHLAB_ON_CHAIN_FEE_RATES = {
  platformRatePerMillion: 5000,
  creatorRatePerMillion: 5000,
};

/**
 * Raydium CPMM AmmConfig index 0 (default `RAYDIUM_CPMM_CONFIG_INDEX`) — verified on mainnet.
 * Separate from LP Fee Key earnings; claimed via CPMM.collectCreatorFee (SOL side).
 */
export const IDX_LAUNCHLAB_CPMM_FEE_RATES = {
  tradeRatePerMillion: 2500,
  creatorRatePerMillion: 500,
};

/** Raydium JustSendit-style curve preset (mainnet) */
export const IDX_LAUNCHLAB_ON_CHAIN_CURVE = {
  supply: "1000000000000000",
  totalSellA: "793100000000000",
  totalFundRaisingB: "85000000000",
  totalLockedAmount: "0",
  migrateTypeCpmm: 1,
  decimals: 6,
  graduationTargetSol: 85,
};

export const IDX_LAUNCHLAB_MAINNET_GLOBAL_CONFIG_ID =
  "6s1xP3hpbAfFoNtUNF8mfHsjr2Bd97JxFJRWLbL6aHuX";

/** Branding defaults for CreatePlatformConfig */
export const IDX_LAUNCHLAB_PLATFORM_BRANDING = {
  name: "IDX Launchlab",
  web: "https://idxsolana.io/idx-launchlab",
};
